import React from 'react'

import lkw from '../../Images/lkw.svg'
import './Navigation.sass'

const Navigation = (props) => {

	const getClassName = (number) => { 
		if (number === props.current) {
			return "active"
		} else if (number < props.current) {
			return "activated"
		}
	}

	return (
		<nav className="no__statusbar">
			<ol>
				<li onClick={() => props.setStep(1)} className={getClassName(1)}>{props.current === 1 && <img className="no__navicon" src={lkw} alt="LKW"/>}<p>1. <span>Lieferumfang</span></p></li>
				<li onClick={() => props.setStep(2)} className={getClassName(2)}>{props.current === 2 && <img className="no__navicon" src={lkw} alt="LKW"/>}<p>2. <span>Heizöl wählen</span></p></li>
				<li onClick={() => props.setStep(3)} className={getClassName(3)}>{props.current === 3 && <img className="no__navicon" src={lkw} alt="LKW"/>}<p>3. <span>Liefer- & Bezahldetails</span></p></li>
				<li onClick={() => props.setStep(4)} className={getClassName(4)}>{props.current === 4 && <img className="no__navicon" src={lkw} alt="LKW"/>}<p>4. <span>Bestellung bestätigen</span></p></li>
			</ol>
		</nav>
	)
}

export default Navigation
